export default __webpack_public_path__ + "static/media/sneak peak 05.0df37206.mp4";